import { GetterTree } from 'vuex';
import {rootStore, modal} from "@/store/types";

export type Getters = {
    isVisible(state: modal): boolean;
    isVisibleSmallMessage(state: modal): boolean;
    getSmallModalMessage(state: modal): string;
    getSmallModalTitle(state: modal): string;
    getMessage(state: modal): string;
    getFooterMessage(state: modal): string;
    getHeaderMessage(state: modal): string;
    getType(state: modal): number;
    isAuthVisible(state: modal): boolean;
    isServicesVisible(state: modal): boolean;
}

export const getters: GetterTree<modal, rootStore> & Getters = {
    isVisible: (state): boolean => {
        return state.show;
    },
    getMessage(state): string {
        return state.modalMessage
    },
    getType(state): number {
        return state.modalType;
    },
    isAuthVisible(state): boolean {
        return state.authModalShow;
    },
    isServicesVisible(state): boolean {
        return state.servicesModalShow;
    },
    getFooterMessage(state: modal): string {
        return state.modalFooterMessage;
    },
    getHeaderMessage(state: modal): string {
        return state.modalHeaderMessage;
    },
    isVisibleSmallMessage(state: modal): boolean {
        return state.smallModalMessageVisibility;
    },
    getSmallModalMessage(state: modal): string {
        return state.smallModalMessageMessage;
    },
    getSmallModalTitle(state: modal): string {
        return state.smallModalMessageTitle;
    }
};